var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    attrs: { prop: _vm.code, label: _vm.name, align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("a", { attrs: { href: _vm.getsrc(scope.row[_vm.code]) } }, [
              _vm._v("下载"),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }